import { NgModule } from '@angular/core';

import { ImageTransformationService } from './image-transformation.service';

@NgModule({
  providers: [ImageTransformationService],
})
export class ImageTransformationModule {}
